<template>
  <div>
    <el-dialog
      width="632px"
      :visible="true"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :modal-append-to-body="false"
      :modal="false"
    >
      <div slot="title">
        <div class="el-dialog__title">
          {{ $t('Integrations_Salesforce_DataMapping_AddDataExtension_Title') }}
        </div>
      </div>
      <div class="items-container">
        <radio-group v-model="selectedExtension">
          <rest-list
            :top-data="topData"
            :payload="extensionsFetchEndpoint"
            ref="list"
            :max-height="500"
            :apply-filters-to-url="false"
            :refresh-after-filters-changed="false"
            @filters-change="filtersChanged"
          >
            <template>
              <rest-list-column
                :title="
                  $t(
                    'Integrations_Salesforce_DataMapping_AddDataExtension_Title_Column'
                  )
                "
                prop="dataExtensionName"
                :sortable="false"
              >
                <template slot-scope="scope">
                  <radio
                    :label="scope.row"
                    :title="scope.row.dataExtensionName"
                  />
                </template>
              </rest-list-column>
            </template>
          </rest-list>
        </radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          @click="selectExtension"
          :disabled="selectedExtension === null"
        >
          <span>{{ $t('Campaign_Dialog_Button_Apply') }}</span>
          <i class="el-icon-arrow-right el-icon--right" />
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import RestList from '@/common/components/rest/RestList'
import { projectEndpoint } from '@/core/helpers'
import RestListColumn from '@/common/components/rest/RestListColumn'
import Radio from '@/common/components/form/Radio'
import RadioGroup from '@/common/components/form/RadioGroup'
import { EventBus } from '@/core/EventBus'
import { cloneDeep, debounce } from 'lodash'
export default {
  name: 'AddDataExtensionDialog',

  components: {
    RadioGroup,
    Radio,
    RestListColumn,
    RestList
  },

  data() {
    return {
      selectedExtension: null,
      topData: [],
      filters: {}
    }
  },

  props: {
    model: {
      type: Object
    }
  },

  computed: {
    extensionsFetchEndpoint() {
      return projectEndpoint({
        method: 'post',
        url: 'integrations/salesforce/get-data-extensions',
        data: {
          ...this.model.params,
          ...this.filters
        }
      })
    }
  },

  methods: {
    handleClose() {
      EventBus.$emit('closeDataExtensionDialog')
    },
    selectExtension() {
      EventBus.$emit('addDataExtension', this.selectedExtension)
    },
    filtersChanged: debounce(function(filters) {
      this.filters = cloneDeep(filters)
      this.$nextTick(() => this.$refs.list.refresh())
    }, 1000)
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/modules/integrations/types/salesforce/AddDataExtensionDialog.vue